import React from 'react';
import { Field } from 'react-final-form';
import { FormField, FormHelp, Input, Label } from '@zillow/constellation';
import { FieldValidator } from '../../../validation/validation';
import { CURRENT_CITY } from '../../../constants/formFieldNames';

export default function CityField() {
  return (
    <Field
      name={CURRENT_CITY}
      format={(city) => city?.trim()}
      formatOnBlur
      render={({ input, meta }) => {
        const { touched, active, error } = meta;
        const isInvalid = touched && !active && Boolean(error);
        return (
          <FormField
            error={isInvalid}
            label={<Label>City</Label>}
            control={<Input {...input} />}
            description={isInvalid && <FormHelp>{error}</FormHelp>}
          />
        );
      }}
      validate={(city) => {
        const errors = new FieldValidator(city).required('Enter a city').build();

        return errors ? errors : null;
      }}
    />
  );
}
